<template>
  <mock-up-main>
    <div v-if="loading" class="fill-height d-flex align-center justify-center white"
         style="position: absolute; inset: 0; z-index: 10;">
      <v-progress-circular color="primary" height="5" indeterminate/>
    </div>
        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کیوآر نوبت دهی'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <intro-slider v-if="value" v-model="computedBanner" :is-slider="false"/>

    <appointment-reserve-view
      v-if="!!value && !!value.appointments && !!value.appointments.items && !!value.appointments.items.length"
      v-model="value.appointments"
      :style="{color: !!value.appointments.sectionColor ? value.appointments.sectionColor.text : '',
             background: !!value.appointments.sectionColor ? value.appointments.sectionColor.backGround : ''}"/>

    <gallery-slider
      v-if="value.PicSelector && hasGallery && value.PicSelector.slider" v-model="value.gallery"
      :description="value.PicSelector.description"
      :style="{'background':value.PicSelector.sectionColor.backGround, 'color':value.PicSelector.sectionColor.text}"
      :title="value.PicSelector.title"/>

    <b-gallery-view
      v-if="value && value.VideoGallery && !value.VideoGallery.slider && !!value.VideoGallery.sectionColor" v-model="value.video_gallery"
      :description="value.VideoGallery.description" :is-img="false"
      :style="{'background':value.VideoGallery.sectionColor.backGround, 'color':value.VideoGallery.sectionColor.text}"
      :title="value.VideoGallery.title" type="video_gallery"/>

    <b-feedback-view
      v-if="value.FeedBack && value.FeedBack.items.length > 0" v-model="value.FeedBack"/>

    <b-footer-view v-if="value.textCards" v-model="value"
                   :style="{'background' : value.textCards.sectionColor.backGround, 'color' : value.textCards.sectionColor.text}"
                   class="mt-10"/>
  </mock-up-main>
</template>

<script>
import MockUpMain from "@/view/pages/businessPage/components/mockUp";
import IntroSlider from "@/view/pages/businessPage/components/view/bIntroSliderView";
import MCategoryView from "@/view/pages/otherQrTypes/menu/cm/mCategoryView";
import AdsComponents from "@/view/components/Product/AdsComponents";
import BFooterView from "@/view/pages/businessPage/components/view/bFooterView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView";
import MProductCard from "@/view/components/Product/mProductCard";
import AppointmentReserveView from "@/view/pages/businessPage/components/view/appointmentReserveView.vue";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "viewAppointment",

  components: {
    AppointmentReserveView,
    UniversalQrModal,
    MProductCard,
    BFeedbackView,
    BGalleryView, GallerySlider, BFooterView, AdsComponents, MCategoryView, IntroSlider, MockUpMain
  },

  props: {
    value: Object,
    loading: Boolean,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data: () => ({
    selectedCategory: 0,
    showQrDialog: false,
  }),

  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    computedBanner() {
      if (this.value?.banner?.gallery && this.value.banner.gallery[0])
        return {
          banner: this.value.banner.gallery[0]
        }
      else {
        return null
      }
    },
    hasGallery() {
      return this.value.gallery?.length > 0 && this.value.gallery?.filter(item => item.images?.length > 0)?.length > 0
    },
    hasVideo() {
      return !!this.value.VideoGallery && !!this.value.video_gallery?.filter(g => !!g.images.length)?.length
    }
  },

  watch: {
    value: {
      deep: true,

      handler() {
        this.$forceUpdate()
      }
    }
  },
}
</script>

<style>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  text-wrap: wrap;
}
.qr-floating-btn {
  position: fixed;
  bottom: 24px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>